import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_RoleDetailTab = _resolveComponent("RoleDetailTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_RoleAuthorizationsTab = _resolveComponent("RoleAuthorizationsTab")
  const _component_DomainCategoryTab = _resolveComponent("DomainCategoryTab")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedRole.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.handleSubmit,
          disabled: _ctx.buttonDisabled
        }, null, 8, ["onClick", "disabled"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplate
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_TabView, {
      class: "roles-tabview",
      "data-test": "tab-view"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.rolesManagement.detail.title')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_RoleDetailTab, {
              selectedRole: _ctx.selectedRole,
              publicRole: _ctx.publicRole,
              onFieldChanged: _ctx.onFieldChange,
              onRoleTypeChanged: _ctx.onRoleTypeChange
            }, null, 8, ["selectedRole", "publicRole", "onFieldChanged", "onRoleTypeChanged"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.rolesManagement.authorizations.title')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_RoleAuthorizationsTab, {
              selectedRole: _ctx.selectedRole,
              authList: _ctx.authorizationList,
              authCBs: _ctx.authorizationCBs,
              onAuthChanged: _ctx.onFieldChange
            }, null, 8, ["selectedRole", "authList", "authCBs", "onAuthChanged"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.rolesManagement.businessModels')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DomainCategoryTab, {
              title: _ctx.$t('managers.rolesManagement.businessModels') + ' ' + _ctx.$t('managers.rolesManagement.categories'),
              categoryList: _ctx.businessModelList,
              selected: _ctx.selectedBusinessModels,
              onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSelectedBusinessModels($event)))
            }, null, 8, ["title", "categoryList", "selected"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.rolesManagement.dataSets')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DomainCategoryTab, {
              title: _ctx.$t('managers.rolesManagement.dataSets') + ' ' + _ctx.$t('managers.rolesManagement.categories'),
              categoryList: _ctx.dataSetList,
              selected: _ctx.selectedDataSets,
              onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedDataSets($event)))
            }, null, 8, ["title", "categoryList", "selected"])
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, null, {
          header: _withCtx(() => [
            _createVNode("span", null, _toDisplayString(_ctx.$t('managers.rolesManagement.kpiCategories')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DomainCategoryTab, {
              title: _ctx.$t('managers.rolesManagement.kpiCategories'),
              categoryList: _ctx.kpiCategoriesList,
              selected: _ctx.selectedKPICategories,
              onChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectedKPICategories($event)))
            }, null, 8, ["title", "categoryList", "selected"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}